import { render, staticRenderFns } from "./FinanceView.vue?vue&type=template&id=6fa695eb&scoped=true"
import script from "./FinanceView.vue?vue&type=script&lang=js"
export * from "./FinanceView.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=6fa695eb&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa695eb",
  null
  
)

export default component.exports